import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupFormLiteComponent } from './signup-form-lite.component';
import { KzFormModule } from '../../../../kz-ui/ui/form/kz-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhoneCodeModule } from '../../../../shared/components/phone-code/phone-code.module';
import { BlockCopyPasteModule } from '../../../../shared/components/block-copy-paste/block-copy-paste.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { KzJumbotronModule } from '../../../../kz-ui/ui/jumbotron/kz-jumbotron.module';
import { KzIconsModule } from '../../../../kz-ui/ui/icon/kz-icons.module';

@NgModule({
    declarations: [
        SignupFormLiteComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PhoneCodeModule,
        KzFormModule,
        KzJumbotronModule,
        NgSelectModule,
        KzIconsModule,
        BlockCopyPasteModule
    ],
    exports: [
        SignupFormLiteComponent
    ],
    providers: []
})
export class SignupFormLiteModule {}
